<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="list-row"
       v-if="store.data
             && store.response
             && store.response.links
              && store.response.links.next
              "
       :style="{top:Math.max(scrollY+itemHeight*maxElementRender,((store.data.length+5)*itemHeight))+'px'}"
  >
    <!--<v-lazy min-height="50">-->
    <v-card class="pagination-summary">
      <div v-if="store.response
             && store.response.links
              && store.response.links.next">
        Loading
      </div>
    </v-card>
    <!--<v-card v-show="isLoadMore">Loading</v-card>-->
    <!--</v-lazy>-->
  </div>

</template>
<style lang="scss" scoped>

</style>

<script lang="ts">

  import {Component, Prop, Vue} from 'vue-property-decorator'


  @Component({
    components: {},
  })
  export default class LoadingDummy extends Vue {
    @Prop() store: any
    @Prop() itemHeight: number
    @Prop() scrollY: number
    @Prop() maxElementRender: number


  }

</script>
